import { useLogin } from "../components/login/context/LoginContext";

import { Button, Text } from '@ui-component-library';


export default function MyAccountForm() {
    const LoginContext = useLogin();

    const next = () => {
        if(LoginContext.isLogged) {
            window.open('/min-skog/', '_self')
        } else {
            LoginContext.setShow(true);
        }
    }

    return <>
        <>
            <div className='flex justify-center w-full'>
                <div className='bg-white rounded-2xl p-8'>
                    <Text variant='subheaderSmallMedium' className='mb-4'>Välkommen</Text>

                    <Text variant='bodySmallRegular'>{LoginContext.isLogged ? 'Börja utforska alla fördelar med att ha din skogsbruksplan digitalt.' : 'Skapa ett konto eller logga in för att börja skapa din digitala skogsbruksplan.'}</Text>

                    <Button variant='primary' className='w-full mt-4' onClick={next}>{LoginContext.isLogged ? 'Till min skogsbruksplan' : 'Skapa konto / Logga in'}</Button>
                </div>
            </div>
            
        </>
    </>
}
